export default __webpack_public_path__ + "static/media/tip2b.0bb91699.png";